var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"meta"},[_c('div',{staticClass:"container",attrs:{"flex":"main:justify"}},[_c('div',{staticClass:"title"},[_vm._v("多多收银系统")]),_c('router-link',{staticClass:"cart",attrs:{"to":"/cart"}},[_c('van-icon',{attrs:{"name":"shopping-cart-o","size":"18px"}}),_vm._v(" 购物车 ")],1)],1)]),_c('layout-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }